@if(isPanelOpen()) {
<div class="backdrop" (click)="togglePanel()"></div>
}

<div class="ida-container">
  <!--  app-root refers to IDA custom component -->
  <!--  TODO: talk to custom element devs to rename it to something unique. For example: `ida-custom-chat`  -->
  @if (isPanelOpen() && hasConsent() && isImpersonating()) {
  <div class="chat-window-container chat-window-container--unavailable">
    <p class="im:body m-0">{{'impersonation.chatbot_unavailable_l' | translate}}</p>
  </div>
  } @else {
  <div class="chat-window-container">
    <app-root [class.d-none]="!hasConsent() || !isPanelOpen()"></app-root>
  </div>
  } @if(isPanelOpen() && !hasConsent()) {
  <rs-web-ida-chatbot-consent-panel
    [legalText]="legalTexts()?.chatbotUsage"
    (closed)="togglePanel()"
    (consentAccepted)="acceptConsent()"
  ></rs-web-ida-chatbot-consent-panel>
  }

  <div (click)="togglePanel()" class="ida-button" role="button">
    @if(isConsentLoading()) {
    <div class="p-8">
      <rs-web-loader></rs-web-loader>
    </div>

    } @else { @if(hasConsent()) {
    <img class="orb" alt="ida-chatbot-button" src="/web/images/png/ida.png" />
    } @else {
    <img class="orb" alt="ida-chatbot-button" src="/web/images/gif/ida.gif" />
    <span class="ask-ida">{{'chat_bot.button_l' | translate}}</span>
    } }
  </div>
</div>
